import { useState } from "react";
import { Link } from "react-router-dom";
import heroBg from "@/assets/hero-bg-new.png";
import TypingAnimation from "./TypingAnimation";
import MiniChatIllustration from "./MiniChatIllustration";
import MiniVoiceIllustration from "./MiniVoiceIllustration";
import MiniEmailIllustration from "./MiniEmailIllustration";
import MiniAIIllustration from "./MiniAIIllustration";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import ContactDialog from "./ContactDialog";

const Hero = () => {
  const { t, language } = useLanguage();
  const [contactOpen, setContactOpen] = useState(false);
  
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-16">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url(${heroBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-background/70 via-background/60 to-background" />
      </div>

      {/* Content */}
      <div className="container relative z-10 px-6 md:px-8 py-16 md:py-24">
        <div className="max-w-4xl mx-auto text-center animate-fade-in-up">
          {/* Logo/Brand */}
          <div className="mb-8">
            <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold tracking-tight mb-4">
              <span className="text-gradient">Fulltrúi</span>
            </h1>
          </div>

          {/* Main Headline with Typing Animation */}
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold mb-8 tracking-tight min-h-[6rem] md:min-h-[7rem]">
            <TypingAnimation 
              slogans={t.hero.slogans}
              typingSpeed={80}
              deletingSpeed={40}
              pauseDuration={2500}
            />
          </h2>

          {/* CTA Button */}
          <Button 
            size="lg" 
            className="text-lg px-8 py-6 h-auto hover-lift"
            onClick={() => setContactOpen(true)}
          >
            {t.hero.cta}
          </Button>

          {/* Mini Illustrations - All Assistants */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mt-16 max-w-[90rem] mx-auto px-4">
            <Link to={`/${language}/products/automation`} className="transition-transform hover:scale-105">
              <MiniAIIllustration />
            </Link>
            <Link to={`/${language}/products/chat`} className="transition-transform hover:scale-105">
              <MiniChatIllustration />
            </Link>
            <Link to={`/${language}/products/voice`} className="transition-transform hover:scale-105">
              <MiniVoiceIllustration />
            </Link>
            <Link to={`/${language}/products/email`} className="transition-transform hover:scale-105">
              <MiniEmailIllustration />
            </Link>
          </div>
        </div>
      </div>

      <ContactDialog open={contactOpen} onOpenChange={setContactOpen} />

      {/* Bottom Gradient */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background to-transparent z-10" />
    </section>
  );
};

export default Hero;
